<template>
  <div class="headersearchtwo">
    <div class="psearch">
      <img src="../assets/logo.png" class="logo" @click="$router.push({name:'Home'})" />
      <input type="text" v-model="searchText" class="prosearch" placeholder="搜索商品" />
      <label>想象无界,创意无边</label>
      <!-- <input type="button" value="搜索" class="submitsearch" @click="searchButton()" /> -->
      <div class="submitsearch" @click="searchButton()">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconShop_Global_Search" />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/icon/iconfont.js";

export default {
  name: "headersearchtwo",
  props: ["proshows", "licolors"],
  watch: {
    licolors: function(a, b) {
      console.log("todel:", a, b);
      // debugger;
    }
  },
  data() {
    return {
      searchText: ""
    };
  },
  methods: {
    searchButton() {
      console.log(this.searchText);
      if (this.searchText.length > 0) {
        this.$router.push({
          path: "search",
          query: {
            search: this.searchText
          }
        });
      } else {
        this.$message({
          message: "请输入您想搜索的商品",
          type: "warning"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.headersearchtwo {
  width: 100%;
  // height: 180px;
  background-color: #ffffff;

  position: relative;
  .psearch {
    width: 1200px;
    height: 140px;
    line-height: 140px;
    margin: 0 auto;
    position: relative;
    /*  background:green;*/
    .logo {
      position: absolute;
      left: 0px;
      top: 40px;
      cursor: pointer;
    }
    .prosearch {
      width: 400px;
      height: 48px;
      line-height: 48px;
      top: 40px;
      left: 720px;
      position: absolute;
      border: 0;
      border: 2px solid red;
      font-size: 16px;
      padding-left: 10px;
      outline: none;
    }

    .icon {
      width: 30px;
      height: 30px;
      fill: currentColor;
      position: absolute;
      margin: 10px 0 0 25px;
    }
    .icon:hover {
      fill: #fff;
    }

    .submitsearch {
      width: 80px;
      height: 48px;
      background-color: red;
      border-radius: 0;
      color: white;
      font-size: 15px;
      border: 0;
      top: 40px;
      right: 0px;
      position: absolute;
      outline: none;
    }
    label {
      height: 50px;
      line-height: 50px;
      position: absolute;
      left: 210px;
      top: 40px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .nav {
    width: 1200px;
    height: 40px;
    margin: 0 auto;
    position: relative;
    ul {
      list-style: none;
      position: absolute;
      bottom: 0;
      li.proshowstyle {
        float: left;
        width: 160px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: rgba(239, 45, 35, 1);
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
      li {
        float: left;
        cursor: pointer;
        width: 160px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
      li:not(:first-child):hover {
        color: #e7001e;
      }
      .colors {
        color: #e7001e;
      }
    }
  }
}
</style>
